import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Divider } from 'grab-ui';
import originSvg from '../../public/images/origin.svg';
import destinationSvg from '../../public/images/destination.svg';
import dropoffOneSvg from '../../public/images/dropoff/one.svg';
import dropoffTwoSvg from '../../public/images/dropoff/two.svg';
import dropoffThreeSvg from '../../public/images/dropoff/three.svg';
import dropoffFourSvg from '../../public/images/dropoff/four.svg';
import dropoffFiveSvg from '../../public/images/dropoff/five.svg';
import dropoffSixSvg from '../../public/images/dropoff/six.svg';
import dropoffSevenSvg from '../../public/images/dropoff/seven.svg';
import dropoffEightSvg from '../../public/images/dropoff/eight.svg';
import dropoffNineSvg from '../../public/images/dropoff/nine.svg';
import styles from './location-step.less';

const DROPOFF_LEVEL = [
  destinationSvg,
  dropoffOneSvg,
  dropoffTwoSvg,
  dropoffThreeSvg,
  dropoffFourSvg,
  dropoffFiveSvg,
  dropoffSixSvg,
  dropoffSevenSvg,
  dropoffEightSvg,
  dropoffNineSvg,
];

const LocationStep = ({ type, name, address, isLast, level, extra }) => {
  const isPickup = type.toUpperCase() === 'PICKUP';

  const pinIcon = useMemo(
    () => {
      if (isPickup) return originSvg;

      return level > DROPOFF_LEVEL.length - 1 || level <= 0
        ? DROPOFF_LEVEL[0]
        : DROPOFF_LEVEL[level];
    },
    [level, isPickup],
  );

  return (
    <div className={styles.locationContainer}>
      <div className={styles.stepContainer}>
        <img src={pinIcon} alt="pin" />

        {!isLast && (
          <Divider className={styles.dividerVertical} type="vertical" />
        )}
      </div>

      <div className={styles.infoContainer}>
        <p className={styles.name}>{name}</p>
        <p className={styles.address}>{address}</p>
        <div className={styles.extra}>{extra}</div>
      </div>
    </div>
  );
};

LocationStep.propTypes = {
  type: PropTypes.oneOf(['dropoff', 'pickup']),
  name: PropTypes.string.isRequired,
  address: PropTypes.string,
  isLast: PropTypes.bool,
  level: PropTypes.number,
  extra: PropTypes.node,
};

LocationStep.defaultProps = {
  type: 'dropoff',
  address: '',
  isLast: false,
  level: 0,
  extra: null,
};

export default LocationStep;
